import { useMemo } from 'react'

const useShowBookingSheet = (appointmentType?: string): boolean => {
  const showSheet = useMemo(() => {
    // Show for initial appointments only
    return !appointmentType?.includes('_fu')
  }, [appointmentType])

  return showSheet
}

export default useShowBookingSheet
